export default __webpack_public_path__ + "static/covid-care-service-kit-img-b697bc25e36e8f8a956ae2acc3182852.png";